import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { GeozonesList } from './GeozonesList';
import { activateGeozoneClicked, deleteGeozoneClicked, editGeozoneClicked, toggleGeozoneEditor } from '../../GeozonesModal/actions';

const enhance = compose(
  connect(store => ({
    geozones: store.geozones.currentDeviceGeozones,
  }),
    dispatch => ({
      toggleEditor() {
        return dispatch(toggleGeozoneEditor());
      },
      deleteGeozone(geozone) {
        return dispatch(deleteGeozoneClicked({ ...geozone }));
      },
      editGeozone(geozone) {
        return dispatch(editGeozoneClicked({ geozone }));
      },
      toggleGeozoneStatus(geozone) {
        return dispatch(activateGeozoneClicked({ geozone }));
      },
    }),
  ),
  translate(['modal'], { wait: true }),
);


export const GeozonesTab = enhance(({ geozones, toggleEditor, deleteGeozone, editGeozone, toggleGeozoneStatus }) =>
  (
    <GeozonesList
      geozones={geozones}
      onCreateHandler={(e) => {
        e.preventDefault();
        toggleEditor();
      }}
      onDeleteHandler={(geozone) => {
        deleteGeozone(geozone);
      }}
      onEditHandler={(geozone) => {
        editGeozone(geozone);
      }}
      onActivateHandler={(geozone) => {
        toggleGeozoneStatus(geozone);
      }}
    />),
);

GeozonesTab.WrappedComponent.propTypes = {
  geozones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  deleteGeozone: PropTypes.func.isRequired,
  toggleEditor: PropTypes.func.isRequired,
  editGeozone: PropTypes.func.isRequired,
  toggleGeozoneStatus: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/Geozones/GeozonesTab.js